// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_CAT_FOOTWEAR = "Obuv";
export const BZ2_CAT_PRAMS = "Ko\u010d\u00e1rky";
export const BZ2_CAT_TOYS = "Hra\u010dky a hry";
export const HOMEPAGE_MORE_CATEGORIES = "Dal\u0161\u00ed kategorie";
export const HOME_SHOW_count_PRODUCTS_FROM_location = ["Prohl\u00e9dni si %(count)s inzer\u00e1t z: %(location)s", "Prohl\u00e9dni si %(count)s inzer\u00e1ty z: %(location)s", "Prohl\u00e9dni si %(count)s inzer\u00e1t\u016f z: %(location)s"];
export const HOME_SHOW_PRODUCTS_FROM_YOUR_LOCATION = "Prohl\u00e9dni si inzer\u00e1ty z tv\u00e9 obce";
